export default __webpack_public_path__ + "static/media/colors-768w.6db9ba4f.webp";